"use client";
import { Image } from "@/components/shared/image";
import { useInView } from "framer-motion";
import { useEffect, useRef, useState } from "react";

export function VideoComponent({
  isPlaying,
  thumbnail,
  videoUrl,
}: {
  isPlaying: boolean;
  thumbnail: string;
  videoUrl: string;
}) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const playerRef = useRef<any>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setIsVideoLoaded] = useState(false);
  const inview = useInView(playerRef, {
    amount: 0.6,
  });

  useEffect(() => {
    if (!inview && isPlaying) {
      const video = playerRef.current;
      if (!video) return;

      video.pause();
    }
  }, [inview, isPlaying]);

  useEffect(() => {
    if (isPlaying) {
      playerRef.current?.play();
    } else {
      playerRef.current?.pause();
    }
  }, [isPlaying]);

  useEffect(() => {
    const videoElement = playerRef.current;

    if (!videoElement) return;

    const handleLoadedData = () => {
      setIsVideoLoaded(true);
    };

    playerRef.current.src = videoUrl;

    playerRef.current.preload = "metadata";
    videoElement.addEventListener("loadeddata", handleLoadedData);

    return () => {
      videoElement.removeEventListener("loadeddata", handleLoadedData);
    };
  }, []);

  return (
    <div className="relative h-full w-full">
      {!isPlaying && (
        <div className="absolute inset-0 z-20 rounded-[2.083vw]">
          <Image src={thumbnail} alt="" fill className="rounded-[2.083vw] object-cover" />
        </div>
      )}
      <video
        ref={playerRef}
        playsInline
        preload="none"
        className="rounded-[2.083vw]"
        controls={true}
        autoPlay={false}
        poster={thumbnail}
        src={videoUrl}
      >
        {/* <source type="video/mp4" /> */}
      </video>
    </div>
  );
}
